export const getDateInFuture = (daysFromNow = 1) => {
  const date = new Date()
  date.setTime(date.getTime() + daysFromNow * 24 * 3600 * 1000)
  return date
}
